export default __webpack_public_path__ + "static/media/wait-spinner-white.4076c576.svg";